export default "./images/survio-2BVTC-assets-settings-24.svg";